import { viewerStrings } from '../copy/strings.js';
import { message, hasText } from '../copy/text.js';
import type { ClassificationRuleSet } from '@cdr-clarity/contracts';
import type { Results } from '../runtime/protocol.js';

export function RulesPreview({
  preview,
  rules,
}: {
  preview: Results['previewRules'];
  rules: ClassificationRuleSet['rules'];
}) {
  return (
    <>
      {hasText(viewerStrings.webComponentsRulesPreview.ofRecordsInTheCurrentScope) ? (
        <p>
          {message(viewerStrings.webComponentsRulesPreview.ofRecordsInTheCurrentScope, {
            value1: preview.sampled,
            value2: preview.total,
          })}
        </p>
      ) : null}
      <table>
        <thead>
          <tr>
            <th>{viewerStrings.webComponentsRulesPreview.record}</th>
            <th>{viewerStrings.webComponentsRulesPreview.origin}</th>
            <th>{viewerStrings.webComponentsRulesPreview.destination}</th>
            <th>{viewerStrings.webComponentsRulesPreview.organizationDirection}</th>
          </tr>
        </thead>
        <tbody>
          {preview.results.map(({ recordId, classification }) => (
            <tr key={recordId}>
              <td>{recordId}</td>
              {[classification.origin, classification.destination].map((endpoint, index) => (
                <td key={index}>
                  {endpoint.category}
                  {endpoint.label ? ` · ${endpoint.label}` : ''}
                  {endpoint.ruleId && (
                    <details
                      open={!hasText(viewerStrings.webComponentsRulesPreview.rule) || undefined}
                    >
                      {hasText(viewerStrings.webComponentsRulesPreview.rule) ? (
                        <summary>
                          {message(viewerStrings.webComponentsRulesPreview.rule, {
                            value1: rules.find((rule) => rule.id === endpoint.ruleId)?.name ?? '',
                          })}
                        </summary>
                      ) : (
                        <summary hidden />
                      )}
                      <dl>
                        {endpoint.evidence.map((evidence, evidenceIndex) => (
                          <div key={`${evidence.field}:${evidenceIndex}`}>
                            <dt>
                              <code>{evidence.field}</code>
                            </dt>
                            <dd>{evidence.value}</dd>
                          </div>
                        ))}
                      </dl>
                    </details>
                  )}
                </td>
              ))}
              <td>{classification.direction}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
